export default "__VITE_ASSET__ACZXi5cN__"